export type CookiePolicy = "essential" | "analytics" | "functional";

export type PartyType = "First Party" | "Third Party";

/** Vendor configuration for a tracked third-party service. */
export interface CookieVendor {
  name: string;
  key: string;
  description: string;
  vendorUrl?: string;
  partyType: PartyType;
}

/** Groups vendors under a single consent policy category. */
export interface CookieParty {
  policy: CookiePolicy;
  vendors: CookieVendor[];
}

/** Configuration passed to the Access Cookie Policy SDK. */
export interface CookieConsentConfig {
  policies: CookiePolicy[];
  parties: CookieParty[];
  applicationId: string;
  policyVersion: string;
  policyUrl: string;
}

/** Response from the Evo cookie SDK after user consent resolution. */
export interface ProductConsent {
  pid: string;
  /** `"*"` = all accepted, `null` = all rejected, array = selective. */
  consent: CookieParty[] | "*" | null;
  policyVersion: string;
}

/**
 * User's cookie consent preferences.
 * @property isResolved - Whether consent has been determined
 * @property analytics - Consent for analytics cookies (GA, Clarity, Coralogix)
 * @property functional - Consent for functional cookies (Intercom)
 */
export interface CookieConsentState {
  isResolved: boolean;
  analytics: boolean;
  functional: boolean;
}

export const CONSENT_STORAGE_KEY = "collins-mobile-cookie-consent";

/**
 * Consent storage version — increment when the cookie policy changes
 * to invalidate existing consent and re-prompt users.
 */
export const CONSENT_VERSION = "2025-06";

declare global {
  interface Window {
    AccessCookiePolicies?: {
      SDK: {
        tabInitialise: (options: {
          config: CookieConsentConfig;
          language?: string;
        }) => Promise<ProductConsent>;
      };
    };
  }
}
